// Loaders
import { BaseActionCreatorLoader } from "../../base/loaders/BaseActionCreatorLoader";
/**
 * Loader class for loading action creators in the Meta OS app
 */
export class MetaOSAppActionCreatorLoader extends BaseActionCreatorLoader {
}
